import React, { FC } from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { Controller, useFormContext } from 'react-hook-form';
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import AutocompleteMultipleValues from '../../../common/AutocompleteMultipleValues';
import useTranslation from '../../../hooks/useTranslation';
import { UserModalPropsType } from './UserModalPropsType';
import { returnRolesOptions } from './utils';
import { roleRestricted, SA } from '../../RoleRestricted/utils';

const UserModal: FC<UserModalPropsType> = ({
  countries,
  loggedInUserEmail,
  userRole,
  userEmail,
  currentUserRole,
}) => {
  const t = useTranslation();

  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  const roles = t('roles');
  const roleOptions = returnRolesOptions(
    userEmail,
    userRole,
    loggedInUserEmail,
    currentUserRole,
  );
  const disabled = roleRestricted([SA], userRole);
  return (
    <Stack spacing={3}>
      <TextField
        required
        label={t('common.name')}
        fullWidth
        disabled
        {...register('name')}
        error={!!errors?.name}
        helperText={errors?.name?.message}
      />

      <TextField
        required
        label={t('common.email')}
        fullWidth
        disabled
        {...register('email')}
        error={!!errors?.email}
        helperText={errors?.email?.message}
      />

      <Controller
        render={({ field: { onChange, value } }) => (
          <FormControl fullWidth required>
            <InputLabel>{t('common.role')}</InputLabel>
            <Select
              value={value ? value : []}
              onChange={(value) => {
                onChange(value);
              }}
              input={<OutlinedInput label={t('common.role')} />}
              error={!!errors?.expansionUserRole}
            >
              {value && !roleOptions.includes(value) && (
                <MenuItem value={value} disabled>
                  {roles[value] || value}
                </MenuItem>
              )}
              {roleOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {roles[option]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        control={control}
        name="expansionUserRole"
      />

      <Controller
        render={({ field: { onChange, value } }) => (
          <>
            <AutocompleteMultipleValues
              disabled={disabled}
              controllerValue={value}
              controllerOnChange={onChange}
              options={countries}
              formStateErrors={errors}
              controllerName="countries"
              label={t('projects.userModal.userCountry')}
              getOptionLabelPropName="countryId"
              renderOptionPropName="countryName"
            />
          </>
        )}
        control={control}
        name="countries"
      />
    </Stack>
  );
};

export default UserModal;
